import React from 'react';

import Layout from '../components/shared/layout';
import SEO from '../components/shared/seo';

const Contact = () => (
  <Layout>
    <SEO title="Contact" keywords={['locevent', 'essonne', '91', 'location', 'materiel', 'reception', 'mariage', 'contact']} />
    <div className="Contact-us">
      <div className="container">
        <div className="text-center">
          Une demande précise ?
          Contactez-nous ici
        </div>
        <form action="https://formspree.io/mbjoqrlv" netlify="true" method="POST" name="contact">
          <div>
            <label>Votre nom: </label>
            <input type="text" name="nom" />
          </div>
          <div>
            <label>Votre email: </label>
            <input type="email" name="email" />
          </div>
          <div>
            <label>Votre téléphone: </label>
            <input type="phone" name="telephone" />
          </div>
          <div>
            <label>Message: </label>
            <textarea name="message" />
          </div>
          <div>
            <button type="submit">Envoyer</button>
          </div>
        </form>
      </div>
    </div>
  </Layout>
);

export default Contact;
